import { render } from "./InputDropzoneInside.vue?vue&type=template&id=c2a3b1b6&scoped=true"
import script from "./InputDropzoneInside.vue?vue&type=script&lang=js"
export * from "./InputDropzoneInside.vue?vue&type=script&lang=js"

import "./InputDropzoneInside.vue?vue&type=style&index=0&id=c2a3b1b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a3b1b6"]])

export default __exports__